module.exports = __webpack_public_path__ + "img/qays.ef660456.jpg";